module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Catriona McPherson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("CATRIONA MCPHERSON was born near Edinburgh, where she received her Ph.D.  Her previous Dandy Gilver mystery, "), _c('I', [_vm._v("Dandy Gilver and the Proper Treatment of Bloodstains")]), _vm._v(", won the Sue Feder Memorial Award in 2012. Catriona lives in Davis, California, with her husband and two cats.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/HGzVdH/tc-custom/9781250030009.jpg?1730634856013",
      "alt": "This image is the cover for the book Dandy Gilver and a Bothersome Number of Corpses, Dandy Gilver Murder Mystery Series"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dandy Gilver and a Bothersome Number of Corpses, Dandy Gilver Murder Mystery Series\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("In this historical cozy mystery set in 1920s Scotland, an upper-class sleuth goes undercover to find a killer at an all-girls school.")]), _c('br'), _c('br'), _vm._v("Bored with her wealthy life after the Great War, aristocratic wife and mother Dandy Gilver decides to become a private investigator. Her current case has her traveling to an all-girls school in the Scottish seaside town of Portpatrick where a childhood friend has disappeared. Soon, Dandy discovers that her missing chum, now a teacher, is not the only thing that’s off in Portpatrick. Other teachers have been vanishing as well . . . at an alarming rate. To find some answers, Dandy must go undercover as a new member of the staff, but one misstep could have her dismissed permanently . . ."), _c('br'), _c('br'), _c('b', [_vm._v("“Fans of historical mysteries and old-fashioned whodunits will enjoy "), _c('i', [_vm._v("Dandy Gilver and a Bothersome Number of Corpses")]), _vm._v(". . . . A very satisfying whodunit that was both intriguing and creepy.” —"), _c('i', [_vm._v("Gumshoe Review")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    St. Martin’s Minotaur\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0